<div class="ws-page ws-page-spacious">
  <header class="page-head">
    <div>
      <p class="kicker">Pilot areas · Registry</p>
      <div class="page-head-title-row">
        <app-page-back-btn />
        <h2>Pilot area registry</h2>
        <app-page-refresh-btn (refresh)="reload()" />
      </div>
      <p class="muted ws-lead">Geographic pilot zones used for LiDAR scans and building compliance checks.</p>
    </div>
  </header>

  <p class="error" *ngIf="error()">{{ error() }}</p>

  <section class="page-card page-card--compact-head">
    <h3 class="panel-title">Registered pilot areas</h3>
    <p class="ws-empty" *ngIf="!rows().length">No pilot areas registered.</p>
    <div class="table-wrap" *ngIf="rows().length">
      <table class="data">
        <thead>
          <tr>
            <th>Name</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let r of rows()">
            <tr>
              <td><strong class="text-primary">{{ r.name }}</strong></td>
              <td><app-status-badge [statusCd]="r.statusCd">{{ r.statusCd }}</app-status-badge></td>
              <td>
                <button type="button" class="btn secondary btn-compact" (click)="togglePilotDetail(r)">
                  {{ isPilotExpanded(r) ? 'Hide' : 'Details' }}
                </button>
              </td>
            </tr>
            <tr class="detail-expand-row" *ngIf="isPilotExpanded(r)">
              <td colspan="3">
                <div class="detail-expand-panel">
                  <dl class="detail-grid">
                    <div>
                      <dt>ID</dt>
                      <dd class="num">{{ r.id }}</dd>
                    </div>
                    <div>
                      <dt>Boundary ref</dt>
                      <dd>{{ r.boundaryRef || '—' }}</dd>
                    </div>
                    <div *ngIf="r.notes">
                      <dt>Notes</dt>
                      <dd class="text-meta">{{ r.notes }}</dd>
                    </div>
                  </dl>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>

  <section class="page-card">
    <button type="button" class="ws-collapse-toggle" (click)="toggleAddForm()">
      <h3 class="panel-title">Add pilot area</h3>
      <span class="toggle-hint">{{ addFormOpen() ? 'Hide' : 'Show' }}</span>
    </button>
    <div class="ws-collapse-panel" *ngIf="addFormOpen()">
      <div class="form-grid">
        <label>Name <input [(ngModel)]="form.name" /></label>
        <label>Boundary ref <input [(ngModel)]="form.boundaryRef" /></label>
        <label>Notes <input [(ngModel)]="form.notes" /></label>
        <label>
          Status
          <select [(ngModel)]="form.statusCd">
            <option value="planned">Planned</option>
            <option value="active">Active</option>
            <option value="completed">Completed</option>
          </select>
        </label>
      </div>
      <button type="button" class="btn primary" (click)="create()">Save pilot area</button>
    </div>
  </section>
</div>

<div class="toast" *ngIf="toast()">{{ toast() }}</div>
